import React, { Component, Fragment } from 'react';
import env from '../../config/env';
import Axios from 'axios';

class Client extends Component {

    state = {
        data: [],
        loading: true,
        firstName: '',
        middleName: '',
        lastName: '',
        email: '',
        phone: '',
        address: '',
        adding: false,
        update: false,
        id: null
    }

    goBack = (e) => {
        this.setState({
            adding: false,
            update: false,
            firstName: '',
            middleName: '',
            lastName: '',
            email: '',
            phone: '',
            address: '',
        })
        e.preventDefault();
    }

    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    go = (e) => {
        this.setState({
            adding: true
        })
        e.preventDefault();
    }

    AddModal = () => {
        return (
            <div style={modalHead} className='col-sm-8 col-md-6'>
                <div style={modalStyle}>
                    <h3> Add New Client </h3><br /><br />
                    <form onSubmit={this.addItem}>
                        <input className='form-control' required type='text' name='firstName' value={this.state.firstName} onChange={this.handleChange} placeholder='First Name' />
                        <input className='form-control' required type='text' name='lastName' value={this.state.lastName} onChange={this.handleChange} placeholder='Last name' />
                        <input className='form-control' required type='text' name='middleName' value={this.state.middleName} onChange={this.handleChange} placeholder='Middle Name' />
                        <input className='form-control' required type='email' name='email' value={this.state.email} onChange={this.handleChange} placeholder='Email' />
                        <input className='form-control' required type='number' name='phone' value={this.state.phone} onChange={this.handleChange} placeholder='Phone Number' />
                        <input className='form-control' required type='text' name='address' value={this.state.address} onChange={this.handleChange} placeholder='Address' />
                        <br />
                        <button type='submit' onClick={this.addItem} className='btn btn-info btn-raised btn-md'> + Add </button>
                        <button onClick={this.goBack} className='btn btn-warning btn-raised btn-md' style={{ float: 'right' }}> Back</button>
                    </form>
                </div>
            </div>
        )
    }


    UpdateModal = (e) => {
        return (
            <div style={modalHead} className='col-sm-8 col-md-6'>
                <div style={modalStyle}>
                    <h3> Update Client </h3><br /><br />
                    <form onSubmit={() => this.updateItem(this.state._id)}>
                        <input className='form-control' required type='text' name='firstName' value={this.state.firstName} onChange={this.handleChange} placeholder='First Name' />
                        <input className='form-control' required type='text' name='lastName' value={this.state.lastName} onChange={this.handleChange} placeholder='Last name' />
                        <input className='form-control' required type='text' name='middleName' value={this.state.middleName} onChange={this.handleChange} placeholder='Middle Name' />
                        <input className='form-control' required type='email' name='email' value={this.state.email} onChange={this.handleChange} placeholder='Email' />
                        <input className='form-control' required type='number' name='phone' value={this.state.phone} onChange={this.handleChange} placeholder='Phone Number' />
                        <input className='form-control' required type='text' name='address' value={this.state.address} onChange={this.handleChange} placeholder='Address' />
                        <br />
                        <button type='submit' onClick={this.updateItem} className='btn btn-info btn-raised btn-md'> + Add </button>
                        <button onClick={this.goBack} className='btn btn-warning btn-raised btn-md' style={{ float: 'right' }}> Back</button>
                    </form>
                </div>
            </div>
        )
    }


    EditItem = (props) => {
        this.setState(props);
        this.setState({ update: true, id: props._id })
        console.log(props);
    }

    addItem = (e) => {
        const url = env.appPath + 'clients/create';
        const { firstName, middleName, lastName, email, phone, address } = this.state;
        const data = { firstName, middleName, lastName, email, phone, address }
        Axios.post(url, data)
            .then((response) => {
                // console.log('response here: ', response);
                // console.log('data here: ', data);
                alert(response.data.status);
            })

        e.preventDefault();
        this.setState({
            adding: false,
            firstName: '',
            middleName: '',
            lastName: '',
            email: '',
            phone: '',
            address: '',
        })
    }


    updateItem = (e) => {
        const url = env.appPath + 'clients/update/' + this.state.id;
        console.log(this.state.id)
        const { firstName, middleName, lastName, email, phone, address } = this.state;
        const data = { firstName, middleName, lastName, email, phone, address }
        Axios.put(url, data)
            .then((res) => {
                // console.log('response for update is: ', res.data)
                alert(res.data.status);
            })
        e.preventDefault();
        this.setState({
            update: false,
            firstName: '',
            middleName: '',
            lastName: '',
            email: '',
            phone: '',
            address: '',
    
        })
    }


    DeleteItem = (id) => {
        console.log('i am here')
        const url = env.appPath + `clients/delete/${id}`;
        Axios.delete(url)
            .then((res) => {
                alert(res.data.status);
                // console.log(res)
            })
    }

    componentDidMount() {
        const url = env.appPath + 'clients';
        Axios.get(url)
            .then((res) => {
                console.log('client response is: ', res.data.data)
                this.setState({
                    data: res.data.data
                })
            }
            )
    }

    componentDidUpdate() {
        const url = env.appPath + 'clients';
        Axios.get(url)
            .then((res) => {
                console.log('client response is: ', res.data.data)
                this.setState({
                    data: res.data.data
                })
            }
            )
    }

    render() {
        const { data } = this.state;
        return (
            <Fragment>
                <section id="content">
                    <div className="page static-page-tables">
                        <div className="b-b mb-10">
                            <div className="row">
                                <div className="col-sm-6 col-xs-12">
                                    <h3 className="h3 m-0">CLIENTS </h3>
                                    <small className="text-muted"> Engaged customers </small>
                                </div>
                                <button className='btn btn-raised btn-info' onClick={this.go} style={{ float: 'right', right: 15 }}> + Add new </button>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-12">
                                <section className="boxs">
                                    <div className="boxs-body p-0">
                                        <div className="table-responsive" style={{ height: '77vh', overflowY: 'scroll' }}>
                                            <table className="table table-middle">
                                                <thead>
                                                    <tr>
                                                        <th>Name</th>
                                                        <th>Address</th>
                                                        <th>Email</th>
                                                        <th>Phone Number</th>
                                                        <th></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        data ?
                                                            data.map((item) => (
                                                                <tr key={item._id}>
                                                                    <td className="nowrap">
                                                                        <strong>{item.firstName + ' ' + item.lastName + ' ' + item.middleName[0].toUpperCase()}</strong>
                                                                    </td>
                                                                    <td className="maw-320">
                                                                        <span className="truncate">{item.address}</span>
                                                                    </td>
                                                                    <td>{item.email}</td>
                                                                    <td> {item.phone} </td>
                                                                    <td>
                                                                        <div className="dropdown">
                                                                            <span className="btn btn-simple dropdown-toggle" data-toggle="dropdown">
                                                                                <i className="fa fa-ellipsis-v"></i>
                                                                            </span>
                                                                            <ul className="dropdown-menu pull-right" style={{ padding: '10%' }}>
                                                                                <li style={pointer} onClick={() => this.EditItem(item)}>
                                                                                    <i className='fa fa-pencil' /> &nbsp;Edit
                                                                            </li>
                                                                                <li className="divider"></li>
                                                                                <li style={pointer} onClick={() => this.DeleteItem(item._id)} >
                                                                                    <i className='fa fa-trash' /> &nbsp;Delete
                                                                            </li>
                                                                            </ul>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            )) :
                                                            <tr>
                                                                <td> Loading ...</td>
                                                            </tr>
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </section>
                                {

                                    this.state.adding ?
                                        this.AddModal() :
                                        this.state.update ?
                                            this.UpdateModal() :
                                            null
                                }
                            </div>
                        </div>
                    </div>
                </section>
            </Fragment>
        )
    }
}

export default Client;

const pointer = {
    cursor: 'pointer'
}

const modalHead = {
    backgroundColor: 'rgba(0,0,0,0.03)',
    height: '90vh',
    width: '100%',
    zIndex: 20,
    position: 'absolute',
    left: 0,
    top: '-10vh',
}

const modalStyle = {
    left: '30%',
    width: '40%',
    zIndex: 19,
    backgroundColor: 'white',
    position: 'absolute',
    padding: '3%',
    top: 100,
    margin: 'auto',
    boxShadow: '1px 0px 7px 1px rgba(0,0,0,0.4)'
}


// WEBPACK FOOTER //
// ./src/Components/Client/index.js